var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMjmJobMatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c26wubifaa",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0379a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alma966xqb",
    y1: 1,
    y2: 0,
    xlinkHref: "#c26wubifaa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6jxw4bj54c",
    x1: 0.545,
    y1: 0.31,
    x2: 0.199,
    y2: 0.813,
    xlinkHref: "#c26wubifaa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wmkelwqz2d",
    x1: 0.5,
    y1: 0.59,
    x2: 0.618,
    y2: 1.299,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xbcdjq8mje",
    x1: 0.5,
    x2: 0.5,
    y2: 1.333,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "MJM-Job Matches"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 13",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "translate(19.451 4.725)",
    style: {
      fill: "url(#c26wubifaa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 14",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "rotate(-30 18.708 -17.323)",
    style: {
      fill: "url(#c26wubifaa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 16",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "rotate(-60 13.327 1.403)",
    style: {
      fill: "url(#c26wubifaa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 17",
    d: "M0 3.165V.836a.836.836 0 1 1 1.672 0v2.329a.836.836 0 0 1-1.672 0z",
    transform: "rotate(-120 19.94 -2.017)",
    style: {
      fill: "url(#alma966xqb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 15",
    d: "M0 3.164V.836a.836.836 0 1 1 1.672 0v2.328a.836.836 0 1 1-1.672 0z",
    transform: "rotate(-150 15.11 1.577)",
    style: {
      fill: "url(#alma966xqb)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.001 5.999)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 168",
    d: "M3.057 1.63a1.427 1.427 0 0 0 0 2.853h7.065a1.427 1.427 0 0 0 0-2.853H3.057m0-1.63h7.065a3.057 3.057 0 1 1 0 6.114H3.057a3.057 3.057 0 0 1 0-6.114z",
    transform: "translate(10.965 6.26)",
    style: {
      fill: "url(#6jxw4bj54c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 166",
    width: 22.6,
    height: 15.708,
    rx: 7.854,
    transform: "translate(6.315 9.317)",
    style: {
      fill: "url(#wmkelwqz2d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 18",
    d: "M2.807 1.625a1.1 1.1 0 0 0-1.123 1.084V13a1.1 1.1 0 0 0 1.123 1.083h16.985A1.1 1.1 0 0 0 20.915 13V2.709a1.1 1.1 0 0 0-1.123-1.083H2.807m0-1.626h16.985A2.759 2.759 0 0 1 22.6 2.709V13a2.76 2.76 0 0 1-2.807 2.709H2.807A2.759 2.759 0 0 1 0 13V2.709A2.759 2.759 0 0 1 2.807 0z",
    transform: "translate(6.315 9.317)",
    style: {
      fill: "url(#xbcdjq8mje)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 187",
    width: 22.6,
    height: 7.982,
    rx: 3.991,
    transform: "translate(6.315 9.317)",
    style: {
      fill: "url(#c26wubifaa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 167",
    width: 4.217,
    height: 5.852,
    rx: 2.108,
    transform: "rotate(90 2.925 17.579)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMjmJobMatches);
export default __webpack_public_path__ + "static/media/MJM-Job Matches.35a8248e1e18398b57ebbfc2d9c6e721.svg";
export { ForwardRef as ReactComponent };